/* eslint-disable prettier/prettier */
import { RootState } from '&store/store';
import React from 'react';
import { connect } from 'react-redux';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/navbar/navbar.component';

const WithNavBar = () => {
	return (
		<>
			<Navbar />
			<Outlet />
		</>
	);
};

const mapStateToProps = (state: RootState) => ({});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
const AppRedux = connector(WithNavBar);

export { AppRedux as WithNavBar };
